import { render } from "./DatepickerPoint.vue?vue&type=template&id=20a9407c&scoped=true"
import script from "./DatepickerPoint.vue?vue&type=script&lang=js"
export * from "./DatepickerPoint.vue?vue&type=script&lang=js"

import "./DatepickerPoint.vue?vue&type=style&index=0&id=20a9407c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a9407c"]])

export default __exports__